var app = angular.module("leonardo");

var FolderFileUpdate = function($scope, $rootScope, FolderFileService, FormErrorsService, AttachmentService) {

  $scope.folder_file = $scope.ngDialogData.entity;
  $scope.errorSize = false;

  $scope.removeFile = function() {
    $scope.errorSize = false;
    $scope.file = null;
    $scope.file_aux = null;
  };

  $scope.onFileUpload = function(file) {
    if (!file) {
      return;
    }
    $scope.errorSize = AttachmentService.checkErrorSize(file);
    if ($scope.errorSize) {
      return;
    }
    $scope.file = file;
  };

  $scope.submit = function() {
    if ($scope.file){
      $scope.Form.file.$setValidity('required', true);
    }
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    FolderFileService.updateFile($scope.folder_file.id, $scope.file).then(function(){
      $rootScope.$broadcast('folder-file:updated');
      $scope.closeThisDialog();
    });
  };
};

app.controller('FolderFileUpdate', ['$scope', '$rootScope', 'FolderFileService', 'FormErrorsService',
  'AttachmentService', FolderFileUpdate]);
